import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = {
  class: "flex-body"
};
const _hoisted_5 = {
  class: "text-left"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  class: "flex"
};
const _hoisted_8 = {
  class: "flex-body"
};
const _hoisted_9 = {
  class: "text-left"
};
const _hoisted_10 = {
  class: "localized-text"
};
const _hoisted_11 = {
  ref: "dvrHWoqqlxKh2GfNhnRVGp_Siwo6oRKXGFnTT4KDlO1E",
  "data-form-block-id": "cedef32c-0c24-ef11-840a-000d3a295d2e"
};
const _hoisted_12 = {
  class: "flex"
};
const _hoisted_13 = {
  class: "flex-body"
};
const _hoisted_14 = {
  class: "error"
};
const _hoisted_15 = {
  class: "text-left"
};
const _hoisted_16 = {
  class: "footer text-left"
};
const _hoisted_17 = ["data-text"];
import { computed, getCurrentInstance, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useAdditionalAttrStore } from "@/stores/AdditionalAttrStore";
import { onUnmounted } from "vue";
import { openFullLoading } from "@/utils/tools";
import { configuratorIdStore } from "@/stores/configuratorIdStore";
export default /*@__PURE__*/_defineComponent({
  __name: 'Web3dViewer',
  props: {
    publicContentString: {},
    cadenasBaseUrl: {},
    isFullscreen: {}
  },
  setup(__props) {
    const dialogForm = ref();
    const {
      t
    } = useI18n();
    const additionalStore = useAdditionalAttrStore();
    const is404 = ref(false);
    const isIframeLoaded = ref(false);
    const showDownloadFrom = ref(false);
    const visibleAlertMessage = ref(false);
    const props = __props;
    const isVisible = ref(false);
    const publicContentString = computed(() => {
      return props.publicContentString;
    });
    const IframeUrl = computed(() => {
      if (is404.value) return "404.html";
      return `${additionalStore.getDataConfig.assetBaseUrl}/web-3d-viewer/index.html?cadenasBaseUrl=${encodeURI(props.cadenasBaseUrl)}&publicContentString=${props.publicContentString}`;
    });
    const web3dViewer = ref(null);
    const errorMessage = ref(t("error.web3dViewerIncomplete"));
    watch(publicContentString, () => {
      onCodeChanged();
    });
    onMounted(() => {
      onCodeChanged();
    });
    watch(showDownloadFrom, () => {
      if (showDownloadFrom.value == true) {
        if (additionalStore.dataConfig && additionalStore.dataConfig.downloadFormSnippet) {
          if (/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi.test(additionalStore.dataConfig.downloadFormSnippet)) {
            const scriptTags = additionalStore.dataConfig.downloadFormSnippet.match(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi);
            if (scriptTags) {
              scriptTags.forEach(scriptTag => {
                const srcMatch = scriptTag.match(/src=["'](https?:\/\/[^"']+)["']/i);
                const scriptElement = document.createElement("script");
                if (srcMatch) {
                  scriptElement.src = srcMatch[1];
                  document.body.appendChild(scriptElement);
                } else {
                  // Inline script
                  const scriptContent = scriptTag.replace(/<script[^>]*>/i, "").replace(/<\/script>/i, "");
                  scriptElement.textContent = scriptContent;
                  document.body.appendChild(scriptElement);
                }
              });
            }
          }
        }
      }
    });
    async function attachInputField(formElement) {
      if (!formElement.querySelector('[name="dvrHWoqqlxKh2GfNhnRVGp_Siwo6oRKXGFnTT4KDlO1E"]')) {
        const midentInput = document.createElement("input");
        midentInput.type = "hidden";
        midentInput.name = "dvrHWoqqlxKh2GfNhnRVGp_Siwo6oRKXGFnTT4KDlO1E";
        midentInput.value = mident.value;
        formElement.appendChild(midentInput);
        const build_id = await configuratorIdStore().getConfiguratorId();
        const buildIdInput = document.createElement("input");
        buildIdInput.type = "hidden";
        buildIdInput.name = "wce_cadenasbuildid";
        buildIdInput.value = build_id.data.code;
        formElement.appendChild(buildIdInput);
        return build_id.data.code;
      }
    }
    let observer = null;
    function onCodeChanged() {
      const targetNode = document.body;
      observer = new MutationObserver(mutationsList => {
        mutationsList.forEach(mutation => {
          mutation.addedNodes.forEach(async node => {
            if (node instanceof HTMLFormElement) {
              const buildId = await attachInputField(node);
              const input = node.querySelector('input[name="wce_cadenasmident"]');
              if (input instanceof HTMLInputElement) {
                input.value = mident.value;
                input.dispatchEvent(new Event("input"));
              }
              const description = node.querySelector('textarea[name="description"]');
              if (description instanceof HTMLTextAreaElement) {
                if (description.innerText.indexOf("{build-id}") === -1) {
                  description.innerText = t("label.buildIdReplacement") + buildId;
                } else {
                  description.innerText = description.innerText.replace("{build-id}", t("label.buildIdReplacement") + buildId);
                }
                description.dispatchEvent(new Event("input"));
              }
            }
          });
        });
      });
      // Start observing changes in the DOM
      observer.observe(targetNode, {
        childList: true,
        subtree: true
      });
      if (publicContentString.value) {
        isVisible.value = true;
      } else {
        errorMessage.value = t("error.web3dViewerIncomplete");
        eventBus.emit("switchToProductImage", true);
      }
    }
    const sendLoginStatusToIframe = () => {
      if (web3dViewer.value?.contentWindow) {
        web3dViewer.value.contentWindow.postMessage({
          type: "login-status",
          status: additionalStore.getDataConfig.isLoggedIn,
          customerData: JSON.stringify(additionalStore.getDataConfig.customerData) || []
        }, "*" // Replace with actual iframe origin
        );
      }
    };
    const sendFrameDownloadStatusToIframe = () => {
      if (web3dViewer.value?.contentWindow) {
        web3dViewer.value.contentWindow.postMessage({
          type: "frame-download-status",
          status: props.isFullscreen
        });
      }
    };
    // const loadExternalScript = (src: string): Promise<void> => {
    //   return new Promise((resolve, reject) => {
    //     // Check if the script is already loaded
    //     if (document.querySelector(`script[src="${src}"]`)) {
    //       resolve(); // If already loaded, resolve immediately
    //       return;
    //     }
    //     // Create a new script element
    //     const script = document.createElement("script");
    //     script.src = src; // External JS file URL
    //     script.async = true; // Set async to true to avoid blocking page load
    //     // Resolve the promise when the script is successfully loaded
    //     script.onload = () => resolve();
    //     script.onerror = (error) => reject(`Script load error: ${error}`);
    //     // Append the script to the body
    //     document.body.appendChild(script);
    //   });
    // };
    const mident = ref("");
    const {
      eventBus
    } = getCurrentInstance()?.appContext.config.globalProperties ?? {
      eventBus: undefined
    };
    // Declare loading outside so it persists between events
    let loading = null;
    const loadListener = event => {
      isIframeLoaded.value = true;
      if (event.data === "iframe-loaded") {
        is404.value = false;
      }
      if (event.source === web3dViewer.value?.contentWindow && event.data.partLoadError) {
        errorMessage.value = t(event.data.partLoadError);
        isVisible.value = false;
        eventBus.emit("switchToProductImage", true);
      }
      if (event.data === "request-login-status") {
        sendLoginStatusToIframe();
      }
      if (props.isFullscreen === "true") {
        sendFrameDownloadStatusToIframe();
      }
      if (event.data.mident) {
        mident.value = event.data.mident;
      }
      if (event.data === "show-loading-true") {
        loading = openFullLoading(false, t("text.loading"));
      }
      if (event.data === "show-loading-false") {
        if (loading && typeof loading.close === "function") {
          loading.close();
          loading = null;
        }
      }
      if (event.data === "error-cad-download") {
        visibleAlertMessage.value = true;
      }
      if (event.data === "show-download-form") {
        showDownloadFrom.value = true;
        // loadExternalScript(
        //   "https://mktdplp102cdn.azureedge.net/public/latest/js/form-loader.js?v=1.84.2007"
        // );
        // loadExternalScript(
        //   "https://mktdplp102cdn.azureedge.net/public/latest/js/ws-tracking.js?v=1.84.2007"
        // );
        // dialogForm.value = true;
      }
      if (event.data === "show-download-form-with-download") {
        eventBus.emit("visibleProduct3dWithDownload", true);
      }
    };
    function web3dViewerLoaded() {
      if (isIframeLoaded.value == false) {
        is404.value = true;
      }
      window.removeEventListener("message", loadListener);
      window.addEventListener("message", loadListener);
    }
    onUnmounted(() => {
      if (observer) {
        observer.disconnect();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [isVisible.value ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        ref_key: "web3dViewer",
        ref: web3dViewer,
        class: "web-3d-viewer",
        src: IframeUrl.value,
        onLoad: web3dViewerLoaded
      }, null, 40, _hoisted_1)) : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1)), _createVNode(_component_el_dialog, {
        modelValue: showDownloadFrom.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showDownloadFrom.value = $event),
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
          innerHTML: _unref(additionalStore).dataConfig.downloadFormSnippet
        }, null, 8, _hoisted_6)])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: dialogForm.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogForm.value = $event),
        "show-close": true,
        "append-to-body": true,
        "modal-class": "configurator-popup",
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("header.dialog.cadDownload")), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("header.dialog.cadDownloadText")), 1), _createElementVNode("div", _hoisted_11, null, 512), _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "d365-mkt-config",
          style: {
            "display": "none"
          },
          "data-website-id": "vrHWoqqlxKh2GfNhnRVGp_Siwo6oRKXGFnTT4KDlO1E",
          "data-hostname": "8a8a0bd272374fe38370cd536a2aa95c.svc.dynamics.com"
        }, null, -1))])])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: visibleAlertMessage.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => visibleAlertMessage.value = $event),
        "modal-class": "configurator-popup configurator-popup-error",
        "show-close": true,
        "append-to-body": true,
        width: "808px",
        center: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "ic"
        }, [_createElementVNode("i", {
          class: "iconfont icon-info"
        })], -1)), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t("error.CadDownload")), 1)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
          class: "wikaButtonConf",
          "data-colour": "white",
          "data-no-border": "",
          onClick: _cache[2] || (_cache[2] = $event => visibleAlertMessage.value = !visibleAlertMessage.value),
          "data-text": _ctx.$t('button.cancel'),
          "data-type": "button"
        }, _toDisplayString(_ctx.$t("button.cancel")), 9, _hoisted_17)])])])])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});